let cache = [];

export function setCache( value ) {
	cache = value;
}

export function getCache() {
	return cache;
}
